import { computed, makeObservable, observable } from "mobx";
import type { IDate, Day, Month, Hour, Minute } from "../types/date";

export class Date implements IDate {
  constructor(date?: IDate) {
    makeObservable(this);

    if (date) {
      this.day = date.day;
      this.month = date.month;
      this.year = date.year;
      this.hour = date.hour;
      this.minute = date.minute;
    }
  }

  @observable
  day: Day = 1;

  @observable
  month: Month = 1;

  @observable
  year: number = 2021;

  @observable
  hour: Hour = 0;

  @observable
  minute: Minute = 0;

  @computed
  get dateString() {
    return `${this.day}/${this.month}/${this.year}  ${this.hour}:${this.minute}`;
  }

  toJSON = (): IDate => ({
    day: this.day,
    month: this.month,
    year: this.year,
    hour: this.hour,
    minute: this.minute,
  });
}
